export const runbookContactConstants = {
  GET_REQUEST: "RUNBOOK_CONTACT_GET_REQUEST",
  GET_SUCCESS: "RUNBOOK_CONTACT_GET_SUCCESS",
  GET_FAILURE: "RUNBOOK_CONTACT_GET_FAILURE",

  GET_BY_ID_REQUEST: "RUNBOOK_CONTACT_GET_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "RUNBOOK_CONTACT_GET_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "RUNBOOK_CONTACT_GET_BY_ID_FAILURE",

  CREATE_REQUEST: "RUNBOOK_CONTACT_CREATE_REQUEST",
  CREATE_SUCCESS: "RUNBOOK_CONTACT_CREATE_SUCCESS",
  CREATE_FAILURE: "RUNBOOK_CONTACT_CREATE_FAILURE",

  UPDATE_REQUEST: "RUNBOOK_CONTACT_UPDATE_REQUEST",
  UPDATE_SUCCESS: "RUNBOOK_CONTACT_UPDATE_SUCCESS",
  UPDATE_FAILURE: "RUNBOOK_CONTACT_UPDATE_FAILURE",

  DELETE_REQUEST: "RUNBOOK_CONTACT_DELETE_REQUEST",
  DELETE_SUCCESS: "RUNBOOK_CONTACT_DELETE_SUCCESS",
  DELETE_FAILURE: "RUNBOOK_CONTACT_DELETE_FAILURE",
};
